import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const importSurveysStatusSelector = (state: State) =>
  state.importSurveys.status;
export const importSurveysIdSelector = (state: State) =>
  state.importSurveys.entities?.id;
export const importSurveysLoadedSelector = isLoaded(
  importSurveysStatusSelector,
);
export const shouldLoadimportSurveysSelector = shouldLoad(
  importSurveysStatusSelector,
);
export const importSurveysRejectedSelector = isRejected(
  importSurveysStatusSelector,
);
export const importSurveysPendingSelector = isPending(
  importSurveysStatusSelector,
);
